import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './UserCard.module.scss';
import { isNonEmptyArray, preventOrphans } from '../utils/utils';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const UserCardSlider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const sliderRef = useRef(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setUsers([
      {
        image: require('../../images/wojtek2.jpg'),
        name: 'Alternative Body Art',
        description: t('woj-desc'),
      },
      {
        image: require('../../images/drx.jpg'),
        name: 'Doktor X Piercing',
        description: t('doc-desc'),
      },
      {
        image: require('../../images/bop.jpg'),
        name: 'Bliss of Pain',
        description: t('bop-desc'),
      },
      {
        image: require('../../images/nigel.jpg'),
        name: 'NIGEL GAMBOA',
        description: t('nig-desc'),
      },
      {
        image: require('../../images/kasia2.jpg'),
        name: 'Skinny Art',
        description: t('kas-desc'),
      },
    ]);
  }, [t, i18n.language]); // rerun when language changes

  useEffect(() => {
    if (sliderRef.current && isNonEmptyArray(users)) {
      // @ts-ignore
      sliderRef.current?.slickGoTo(0);
    }
  }, [sliderRef, users]);

  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    prevArrow: <FaChevronLeft />,
    nextArrow: <FaChevronRight />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 688,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          infinite: true,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          arrows: true,
          infinite: true,
        },
      },
    ],
  };

  if (!isNonEmptyArray(users)) {
    return 'loading...';
  }

  return (
    <div className={styles.cardWrapper} style={{ display: 'block' }}>
      <Slider ref={sliderRef} {...settings}>
        {users.map((user, i) => (
          <div key={i}>
            <div className={styles.inner}>
              <div className={styles.imgWrap}>
                <img
                  src={user.image}
                  alt='zdjecia profilowe naszych gospodarzy'
                />
              </div>
              <div className={styles.contentWrap}>
                <p className={styles.name}>{user.name}</p>
                <p className={styles.description}>
                  {preventOrphans(user.description)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default UserCardSlider;
